import React, { useEffect } from 'react';
import moment from 'moment';
import { feachTimeTypeToFilterTimeType } from '@intelligence/utils/common';
import {
  // 单选、多选国家筛选器
  COMPOSED_COUNTRY_SELECT as FILTER_COMPOSED_COUNTRY_SELECT,
  // 时间筛选器的key
  RANGE_TIME as FILTER_RANGE_TIME,
} from '@intelligence/components/Filter/FilterBase/_config';

import type { IDateTypely } from '@intelligence/types/common';
import type { IMobileDetailsOverlapFilterParams } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap/types';

export default function useUpdateFiltersFormValue(props: {
  fetchParams: IMobileDetailsOverlapFilterParams;
  formValue: any;
  setFormValue: React.Dispatch<React.SetStateAction<any>>;
}) {
  const { fetchParams, formValue, setFormValue } = props || {};

  // 更新国家筛选器的value
  const updateComposedCountrySelectFormValue = (formValue: any, markets: string[]): any => {
    const composedCountrySelectCountryTmp = markets?.[0] || '';
    return {
      ...formValue,
      [FILTER_COMPOSED_COUNTRY_SELECT]: {
        value: {
          ...formValue?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value,
          countries: composedCountrySelectCountryTmp ? [composedCountrySelectCountryTmp] : ['us'],
        },
      },
    };
  };

  // 更新时间筛选器的value
  const updateRangeTimeFormValue = (
    formValue: any,
    granularity: IDateTypely,
    startDate: string,
    endDate: string,
  ): any => {
    const dateTypely = granularity || 'monthly';
    return {
      ...formValue,
      [FILTER_RANGE_TIME]: {
        ...formValue?.[FILTER_RANGE_TIME],
        type: feachTimeTypeToFilterTimeType(dateTypely) || 'month',
        value: [moment(startDate), moment(endDate)],
      },
    };
  };

  useEffect(() => {
    let formValueTmp = { ...formValue };
    // 更新国家筛选器的value
    formValueTmp = updateComposedCountrySelectFormValue(formValueTmp, fetchParams?.markets);
    // 更新时间筛选器的value
    formValueTmp = updateRangeTimeFormValue(
      formValueTmp,
      // @ts-ignore
      fetchParams?.granularity,
      // @ts-ignore
      fetchParams?.start_date,
      // @ts-ignore
      fetchParams?.end_date,
    );
    setFormValue(formValueTmp);
  }, [fetchParams?.markets, fetchParams?.granularity, fetchParams?.start_date, fetchParams?.end_date]);
}
